/* eslint-disable multiline-ternary */
import React from 'react'
import CardInstitutional from './CardInstitutional'
import CardProduct from './CardProduct'
import CardRetail from './CardRetail'

const config = {
  types: [],
  modifiers: [
    { title: 'default', isDefault: true },
    'inverse',
    'image',
    'video',
    'inverse',
    'horizontal'
  ],
  states: []
}

const cards = {
  retails: 'CardRetail',
  product: 'CardProduct',
  institutional: 'CardInstitutional'
}

export default function useCard() {
  const getCardType = (keys) => {
    const currentCard = keys.find((it) => Object.keys(cards).includes(it))

    return cards[currentCard] ?? cards.institutional
  }

  const getCardIcon = (icon) =>
    icon ? (
      <span
        className={`mdn-CardInstitutional-icon mdn-Icon--lg mdn-Icon-${icon}`}
        aria-hidden={`${icon ? 'false' : 'true'}`}
      ></span>
    ) : (
      ''
    )

  const renderComponent = (cardType, props) => {
    const { children } = props
    switch (cardType) {
      case 'CardRetail':
        return <CardRetail {...props} config={config} />

      case 'CardProduct':
        return <CardProduct {...props} config={config} />

      default:
        return (
          <CardInstitutional
            {...props}
            config={config}
            getCardIcon={getCardIcon}
          >
            {' '}
            {children}{' '}
          </CardInstitutional>
        )
    }
  }

  return {
    config,
    getCardIcon,
    getCardType,
    renderComponent
  }
}
